const dateWithTimezone = new Date()
  .toLocaleDateString("en-US", { timeZoneName: "short" })
  .split(", ");
export const SHORT_TIMEZONE =
  dateWithTimezone.length > 1 ? dateWithTimezone[dateWithTimezone.length - 1] : "Local Time";

/**
 * Prevents changing date when UTC is converted to browser timezone
 * @param input
 */
export const browserUtcDate = (input: Date | string): Date => {
  const d = typeof input === "string" ? new Date(input) : input;
  const offset = (d.getTimezoneOffset() / 60) * -100;
  return new Date(d.toUTCString() + `${offset > 0 ? "+" : ""}${offset}`);
};

/**
 * Ensures ISO string is converted to browser timezone, handling missing Zulu/00:00 offset
 * @param input
 */
export const utcBrowserTime = (input: string): Date => {
  return new Date(/(Z|\+00:00)$/.test(input) ? input : `${input}Z`);
};

export const formatDateTime = (dateString?: string, options?: { hour?: "2-digit" | "numeric" }) => {
  if (!dateString) {
    return "";
  }
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: options?.hour ?? "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const getDatePickerValue = (value?: any, preserveUtc = false) => {
  if (!value) {
    return null;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (preserveUtc) {
    return browserUtcDate(d);
  }
  return d;
};
